import styled from 'styled-components';
import {StrategyTableContainer as BaseStrategyTableContainer} from '../../../pages/Strategy/styles';

/**
 * Mesmo container da listagem /estrategias, com min-width adequado a 4 colunas.
 */
export const StrategyReportTableContainer = styled(BaseStrategyTableContainer)`
    width: 100%;
    align-self: stretch;

    .MuiTable-root {
        width: 100% !important;
        min-width: 100% !important;
        table-layout: auto;
    }
`;

export const OpsPrimary = styled.div`
    font-weight: 600;
    color: #e0e0e0;
    margin-bottom: 6px;
    line-height: 1.35;
`;

export const OpsMeta = styled.div`
    font-size: 0.75rem;
    line-height: 1.5;
    color: rgba(224, 224, 224, 0.65);
`;
